<template>
  <div class="login">
    <!-- 导航栏 -->
    <van-nav-bar :border="false">
      <template #left>
        <van-icon name="cross" size=".7rem" color="#FF9D11" @click="backHome" />
      </template>
      <template #right>
        <router-link
          class="r-title"
          tag="span"
          :to="{ name: 'login-reg-retrieve', query: { id: 1 } }"
          >注册账号</router-link
        >
      </template>
    </van-nav-bar>
    <!-- 背景 -->
    <div class="login-wrapper">
      <section class="logo" v-show="false">
        <img src="@assets/image/login-reg/61logo.png" alt />
      </section>
      <!-- 验证码登录 -->
      <section class="code-login" v-if="codeLogin">
        <div class="phone">
          <input type="number" v-model="phone" placeholder="请输入手机号" />
        </div>
        <div class="code">
          <input type="number" placeholder="验证码" v-model="code" />
          <button
            @click.prevent="getCode('quick_login')"
            class="code-btn"
            :disabled="!codeShow"
          >
            <span v-show="codeShow">获取验证码</span>
            <span v-show="!codeShow" class="count">{{ count }}</span>
          </button>
        </div>
        <p class="reg-password">
          <router-link
            tag="span"
            :to="{ name: 'login-reg-retrieve', query: { id: 2 } }"
            >忘记密码</router-link
          >
          <span @click="switchLogin('phone')">密码登录</span>
        </p>
        <div class="confirm" @click="onCodeLogin">登录</div>
      </section>
      <!-- 手机号登录 -->
      <section class="password-login" v-else>
        <div class="phone">
          <input type="number" v-model="phone1" placeholder="请输入手机号" />
        </div>
        <div class="password">
          <input type="password" v-model="password" placeholder="请输入密码" />
        </div>
        <p class="code-password">
          <router-link
            tag="span"
            :to="{ name: 'login-reg-retrieve', query: { id: 2 } }"
            >忘记密码</router-link
          >
          <span @click="switchLogin('phone')">手机号登录</span>
        </p>
        <div class="confirm" @click="onPhoneLogin">登录</div>
      </section>
    </div>
  </div>
</template>

<script>
import { contTools, lyTool } from "@/mixins/contMixins";
import wapApiFun from "@/servers/wap-module/apiFun";
import comTools from "@/assets/js/until";
export default {
  name: "login",
  mixins: [contTools, lyTool],
  components: {},
  data() {
    return {
      phone: "",
      phone1: "",
      code: "",
      password: "",
      count: "",
      timer: "",
      codeShow: true,
      codeLogin: true,
    };
  },
  watch: {},
  computed: {},
  created() {
    console.log(1111, this.urlObj);
  },
  methods: {
    backHome() {
      let _path = this.$cookies.get("routePath") || "/home" || "/";
      console.log(_path);

      if (this.$cookies.get("userToken")) {
      }
      if (_path == "/login") {
        if (this.urlObj.warn) {
          this.$router.go(-1);
        } else {
          this.$router.replace({ path: "/" });
        }
      } else {
        this.$router.replace({ path: _path });
      }
    },
    switchLogin(type) {
      console.log(type);
      this.codeLogin = !this.codeLogin;
    },
    // 验证码登录
    onCodeLogin() {
      if (
        this.inputCheck(this.phone, "phone") &&
        this.inputCheck(this.code, "yzm")
      ) {
        let urlObj = comTools.getRequest();
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.phone,
          pwd: this.getMd5(this.password),
          vcode: this.code,
          client_id: urlObj.client_id || this.getIdfa(),
          device_id:
            urlObj.device_id ||
            this.getMd5(`${urlObj.client_id}${urlObj.client_idv}`),
        });
        data.sign = comTools.querySort(data);
        wapApiFun.codeLogin(data).then((res) => {
          if (res.code == 200) {
            this.$toast({
              message: res.msg,
              duration: 2000,
            });
            // if (this.$route.query.warn === "1001") {
            //   this.$router.go(-1);
            // } else {
            //   this.$router.replace({ path: "/" });
            // }
            this.loginBack(res.data.user_token, res.data.mobile);
          } else {
            this.$toast({
              message: res.msg,
              duration: 2000,
            });
          }
        });
      }
    },
    // 手机号登录
    onPhoneLogin() {
      if (
        this.inputCheck(this.phone1, "phone") &&
        this.inputCheck(this.password, "pwd")
      ) {
        let urlObj = comTools.getRequest();
        let data = comTools.assignObj(this.wapConfig(), {
          mobile: this.phone1,
          pwd: this.getMd5(this.password),
          client_id: urlObj.client_id || this.getIdfa(),
          device_id:
            urlObj.device_id ||
            this.getMd5(`${urlObj.client_id}${urlObj.client_idv}`),
        });
        data.sign = comTools.querySort(data);
        wapApiFun.pwdLogin(data).then((res) => {
          if (res.code == 200) {
            this.$toast({
              message: res.msg,
              duration: 2000,
            });
            // if (this.$route.query.warn === "1001") {
            //   this.$router.go(-1);
            // } else {
            //   this.$router.replace({ path: "/" });
            // }
            this.loginBack(res.data.user_token, res.data.mobile);
          } else {
            this.$toast({
              message: res.msg,
              duration: 2000,
            });
          }
        });
      }
      // this.loginBack("userToken100000000");
    },
    // 登录后跳转
    loginBack(token, mobile) {
      console.log("到了", this.urlObj);
      this.$store.commit("setMobile", mobile);
      if (this.$route.query.warn == 1001) {
        this.$router.go(-1);
        this.$cookies.set("userToken", token);
        this.$cookies.set("mobile", mobile);
      } else {
        this.$cookies.set("userToken", token);
        this.$cookies.set("mobile", mobile);
        let redirect = decodeURIComponent(this.urlObj.redirect || "/");
        this.$router.replace({ path: redirect });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "~@/assets/css/com.less";
.login {
  width: 100%;
  .van-nav-bar {
    .r-title {
      .theme-color();
    }
  }

  .login-wrapper {
    width: 100%;
    // min-height: calc(~"100vh - 46px");
    background: url("~@assets/image/login-reg/bg.jpg") no-repeat;
    background-size: 100% auto;
    position: relative;
    .logo {
      width: 50%;
      margin: 0 auto;
      padding-top: 2rem;
      img {
        .img();
      }
    }
    .code-login,
    .password-login {
      width: 85%;
      margin: 0 auto;
      padding-top: 6rem;
      .phone,
      .password,
      .code {
        padding-bottom: 0.3rem;
        border-bottom: 1px solid #ddd;
        input {
          // padding-left: .2rem;
        }
      }
      .password {
        padding-top: 0.8rem;
      }
      .code {
        padding-top: 0.8rem;
        .jc-between();
        .code-btn {
          .theme-color();
          // font-size: 0.3rem;
        }
      }
      .reg-password,
      .code-password {
        .jc-between();
        .theme-color();
        padding: 0.5rem 0;
      }
      .confirm {
        // position: absolute;
        // bottom: 2.5rem;
        // left: 50%;
        // transform: translate(-50%, 0);
        width: 60%;
        margin: 2rem auto;
        text-align: center;
        color: #fff;
        .theme-bg-color();
        padding: 0.3rem 0;
        font-size: 0.5rem;
        .borderRadius(0.2rem);
      }
    }
  }
}
</style>
